import React from 'react';

const statsData = [
    { id: 1, value: "8+", label: "Years In Business" },
    { id: 2, value: "15+", label: "Industries serve" },
    { id: 3, value: "50+", label: "Projects Delivered" },
    { id: 4, value: "95%", label: "Client Retention" }
];

const OurAchievementsSection = () => {
    return (
        <section className="w-full bg-[#FFFFFF] pb-16 sm:pb-20 lg:pb-24 overflow-hidden select-none text-left">
            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px]">

                <div className="w-full mb-12 lg:mb-16">
                    <h2 className="text-[#01386A] font-sora font-[600] lg:text-[30px] text-[20px] leading-[1.2] tracking-tight">
                        Our Achievements
                    </h2>
                </div>

                <div className="flex flex-col lg:flex-row items-stretch gap-8 lg:gap-[16px] w-full">

                    <div className="w-full lg:w-[50%] grid grid-cols-1 sm:grid-cols-2 gap-[8px] lg:gap-[12px]">
                        {statsData.map((stat) => (
                            <div
                                key={stat.id}
                                className="group relative w-full bg-[#F0F0F0] p-8 sm:p-10 min-h-[180px] flex flex-col justify-center items-start overflow-hidden transition-all duration-300"
                            >
                                <div className="relative z-10 flex flex-col gap-3">
                                    <span className="text-[#01386A] font-sora text-[20px] sm:text-[40px] font-[500] tracking-tight leading-none transition-colors duration-300">
                                        {stat.value}
                                    </span>
                                    <span className="text-[#49577A] font-graphik text-[14px] sm:text-[16px] font-[500] tracking-wide">
                                        {stat.label}
                                    </span>
                                </div>

                                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]" />

                                <div className="absolute bottom-0 left-0 h-[4px] w-0 bg-[#ED6800] group-hover:w-full transition-all duration-500 ease-out z-20" />
                            </div>
                        ))}
                    </div>

                    <div className="w-full lg:w-[50%] min-h-[300px] lg:min-h-auto relative overflow-hidden">
                        <img
                            src="/assets/transforming/img7.png"
                            alt="Achievements Visual"
                            className="w-full h-full object-cover"
                        />
                    </div>

                </div>

            </div>
        </section>
    );
};

export default OurAchievementsSection;